import ScrollCarousel from '../../components/ScrollCarousel';

export const SELECTORS = {
  viewport: '[data-hero-dual-image-content-carousel-viewport]',
  track: '[data-hero-dual-image-content-carousel-track]',
};

/**
 * The desktop hero content overlay — the one carousel the visitor actually
 * drives. Its `change` event drives both image strips.
 */
export default (el, handlers = {}) => {
  if (!el) return null;

  return new ScrollCarousel(el, {
    selectors: SELECTORS,
    on: handlers,
    initialIndex: 0,
    prevNextButtons: true,
    pageDots: true,
    // Flickity `wrapAround: true`.
    loop: true,
    adaptiveHeight: true,
    draggable: true,
    slidesPerView: 1,
    // `arrowShape` is dropped: the arrows are styled in HeroDualImage.scss
    // rather than drawn from an injected SVG path.
    ariaLabel: 'Hero carousel',
  });
};
